import { Modal } from "components/designV2/modal/modal";
import { StatusBanner } from "components/designV2/statusBanner/statusBanner";
import { ScheduleStatus } from "model/Schedule";
import { useTranslation } from "react-i18next";
import type {
  ScheduleSection,
  ScheduleShiftItem,
  ScheduleWorkerRow,
} from "web-apps/company/components/schedule/types/schedule.types";
import {
  formatDateLabel,
  formatShiftTimeRange,
} from "web-apps/company/components/schedule/utils/schedule.dates";
import {
  getBlockStatusStyling,
  getShiftDetailTexts,
} from "web-apps/company/components/schedule/utils/schedule.status";
import {
  FooterNote,
  ModalContent,
  Section,
  SectionTitle,
  SectionValue,
} from "./notAvailableShiftModal.styled";

interface Props {
  isOpen: boolean;
  section: ScheduleSection;
  shift: ScheduleShiftItem;
  worker: ScheduleWorkerRow;
  onClose: () => void;
}

export const NotAvailableShiftModal = ({
  isOpen,
  section,
  shift,
  worker,
  onClose,
}: Props): JSX.Element => {
  const { t, i18n } = useTranslation();
  const styling = getBlockStatusStyling(ScheduleStatus.NOT_AVAILABLE);
  const statusTexts = getShiftDetailTexts(ScheduleStatus.NOT_AVAILABLE, t, {
    name: worker.heading,
  });
  const timeLine = formatShiftTimeRange(
    ScheduleStatus.NOT_AVAILABLE,
    shift.startTime,
    shift.endTime,
    i18n.language,
    t,
  );

  return (
    <Modal
      label={statusTexts.label}
      isOpen={isOpen}
      onClose={onClose}
      size="medium"
    >
      <ModalContent>
        <StatusBanner
          iconName="v2/clock"
          label={statusTexts.label}
          subLabel={statusTexts.text}
          textColor={styling.color}
          backgroundColor={styling.backgroundColor}
          fullWidth
        />
        <Section>
          <SectionTitle>{t("Schedule.Worker")}</SectionTitle>
          <SectionValue>{worker.heading}</SectionValue>
        </Section>
        <Section>
          <SectionTitle>{t("Schedule.Date")}</SectionTitle>
          <SectionValue>
            {formatDateLabel(shift.startTime, i18n.language)}
          </SectionValue>
        </Section>
        <Section>
          <SectionTitle>{t("Schedule.Time")}</SectionTitle>
          <SectionValue>{timeLine}</SectionValue>
        </Section>
        <Section>
          <SectionTitle>{t("Schedule.Team")}</SectionTitle>
          <SectionValue>{section.text}</SectionValue>
        </Section>
        <FooterNote>
          {t("Schedule.NotAvailableFooterNote", { name: worker.heading })}
        </FooterNote>
      </ModalContent>
    </Modal>
  );
};
